import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth, GoogleAuthProvider } from "firebase/auth";

const firebaseConfig = {
  apiKey: "AIzaSyAmCTZz_ammZdOi_gCmqP97v5AohzA61vU",
  authDomain: "tmuaprep.firebaseapp.com",
  projectId: "tmuaprep",
  storageBucket: "tmuaprep.appspot.com",
  messagingSenderId: "832898139619",
  appId: "1:832898139619:web:3d13e57a49435dfdb20cd6",
  measurementId: "G-MPVEL1W61F"
};

const app = initializeApp(firebaseConfig);

export const db = getFirestore(app);
export const auth = getAuth(app);
export const googleProvider = new GoogleAuthProvider();
